import Input from "../../component/ui/Input";
import {
  gamesSportOptions,
  playerFilter,
  sportPlayerData,
} from "../../helper/constant";
import SelectField from "../../component/ui/SelectField";
import { Cross, ListFilter, X } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import Button from "component/ui/Button";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPlayerList, getUserDetails } from "store/slice/profile";
import LocationPicker from "component/ui/LocationPicker";
import { getCurrentcoords } from "helper/appConstant";
import { getUserDetail, sendJoinAllCardRequest } from "store/slice/profile";
import { useNavigate } from "react-router-dom";


const SportCard = () => {
  const [dropdown, setDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const handleDropdown = () => setDropdown((prev) => !prev);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const [selectedSport, setSelectedSport] = useState(null);
  const navigate = useNavigate()

  const [location, setLocation] = useState({
    address: "",
    latitude: null,
    longitude: null,
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setLocation((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));

        // ⏳ wait a bit to ensure Google Maps is ready
        setTimeout(async () => {
          const address = await getAddressFromCoords(lat, lng);

          setLocation((prev) => ({
            ...prev,
            address,
          }));
        }, 500);
      },
      () => console.warn("GPS permission denied")
    );
  }, []);




  const getAddressFromCoords = async (lat, lng) => {
    if (!window.google || !window.google.maps) {
      console.warn("Google Maps not loaded yet");
      return "";
    }

    return new Promise((resolve) => {
      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode(
        { location: { lat, lng } },
        (results, status) => {
          if (status === "OK" && results?.length) {
            resolve(results[0].formatted_address);
          } else {
            resolve("");
          }
        }
      );
    });
  };



  useEffect(() => {
    const lat = location.latitude;
    const lng = location.longitude;

    if (!lat || !lng) return; // 🛑 don't call API

    const payload = {
      language: "en",
      page: 1,
      perPage: 10,
      type: "player",
      category: selectedSport || "",
      latitude: lat,
      longitude: lng,
    };

    dispatch(getPlayerList(payload, setLoading));
  }, [selectedSport, location.latitude, location.longitude]);





  const { joinRequestPlayerList } = useSelector(
    (state) => state.profile
  );
  const players = joinRequestPlayerList?.data || [];

  const fetchPlayers = () => {
    const coords = getLatLng();
    if (!coords) return; // 🛑 STOP API

    const payload = {
      language: "en",
      page: 1,
      perPage: 10,
      type: "player",
      category: selectedSport || null,
      latitude: coords.lat,
      longitude: coords.lng,
    };

    dispatch(getPlayerList(payload, setLoading));
  };




  const getLatLng = () => {
    // 1️⃣ From selected location
    if (location.latitude && location.longitude) {
      return {
        lat: location.latitude,
        lng: location.longitude,
      };
    }



    return null;
  };



  useEffect(() => {

    console.log("location", location)
    if (location.latitude && location.longitude) {
      fetchPlayers();
    }
  }, [selectedSport, location.latitude, location.longitude]);


  return (
    <>
      {loading && (
        <p className="text-center text-sm text-gray-500">
          Loading players...
        </p>
      )}

      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12 px-4">
        <div className="lg:max-w-5xl w-full mx-auto">
          {/* Header Section */}
          <div className="bg-white shadow-lg border border-gray-200 ">
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-8 py-4">
              <h2 className="text-2xl font-semibold text-white mb-2">
                Sport/Game Cards
              </h2>
              <p className="text-blue-50 text-sm">
                Select your sport and manage player details
              </p>
            </div>

            {/* Form Section */}
            <div className="space-y-6 p-6">
              {/* Sport and Location Row */}
              <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
                <div className="transform transition-all">
                  <SelectField
                    label="Select Sport/Game"
                    placeholder="Select Sport/Game"
                    options={gamesSportOptions}
                    value={selectedSport}
                    onChange={(value) => setSelectedSport(value)}
                    isRequired
                  />

                </div>

                <div className="relative flex items-center z-50 overflow-visible">
                  <div className="w-[90%]">
                    <LocationPicker
                      label="Location"
                      placeholder="Search location"
                      value={location.address}
                      onChange={(place) => {
                        // ✅ CASE 1: cleared input
                        if (!place || !place.geometry) {
                          setLocation({
                            address: "",
                            latitude: null,
                            longitude: null,
                          });
                          return;
                        }

                        // ✅ CASE 2: valid Google place selected
                        setLocation({
                          address: place.formatted_address || "",
                          latitude: place.geometry.location.lat(),
                          longitude: place.geometry.location.lng(),
                        });
                      }}
                    />



                  </div>

                  <ListFilter
                    onClick={handleDropdown}
                    className="w-[10%] mt-5 cursor-pointer text-highlight relative"
                  />

                  <div
                    className={`absolute top-full right-0 z-50 ${dropdown ? "block" : "hidden"
                      } bg-white rounded-lg shadow-lg w-40`}
                  >
                    <ul className="py-2 text-sm text-white bg-gray-900 rounded-lg">
                      {playerFilter.map((item, index) => (
                        <li key={index}>
                          <button className="block w-full text-left px-4 py-2 hover:bg-[#2bace2]">
                            {item}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              {/* Players Section */}
              <div className="border-t border-gray-200 pt-4">
                <h3 className="text-xl font-semibold text-gray-800">
                  Player Cards
                </h3>
                <p className="text-sm text-gray-600 mt-1">
                  {players.length} player card{players.length !== 1 ? "s" : ""} available
                </p>
              </div>

              <div className="grid md:grid-cols-2 grid-cols-1 gap-4">
                {loading ? (
                  <p className="text-center text-gray-500">Loading players...</p>
                ) : players.length === 0 ? (
                  <p className="text-center text-gray-500">No players found</p>
                ) : (
                  players.map((player, index) => (
                    <div
                      key={player?.id || index}
                      className="group relative bg-gradient-to-br from-white to-gray-50 rounded-xl p-3 border border-gray-200 hover:border-[#2BACE2] hover:shadow-md transition-all duration-300 cursor-pointer"
                      onClick={() => setSelectedPlayer(player)}
                    >
                      <div className="flex items-center gap-4">
                        <div className="md:w-12 md:h-12 w-10 h-10 rounded-full bg-gradient-to-br from-[#2BACE2] to-[#1a8ec4] text-white flex items-center justify-center text-xl font-bold">
                          {player?.name?.charAt(0)?.toUpperCase()}
                        </div>

                        <div className="flex-1 min-w-0">
                          <p className="text-base font-semibold text-gray-800 truncate">
                            {player?.name}
                          </p>
                          <p className="text-xs text-gray-600">
                            {player?.category || "N/A"}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedPlayer && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm px-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fadeIn">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#2BACE2] to-[#1a8ec4] px-6 py-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold text-white">
                Player Details
              </h3>
              <button
                onClick={() => setSelectedPlayer(null)}
                className="text-white text-xl hover:opacity-80"
              >
                ✕
              </button>
            </div>

            {/* Content */}
            <div className="p-6 space-y-6 md:h-auto h-96 overflow-y-auto">
              {/* Player identity */}
              <div className="flex md:flex-row flex-col justify-between md:items-center md:gap-0 gap-2">
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#2BACE2] to-[#1a8ec4] text-white flex items-center justify-center text-xl font-bold shadow-md shrink-0">
                    {selectedPlayer?.name?.charAt(0)?.toUpperCase()}                  </div>

                  <div className="">
                    <p
                      className="text-lg font-semibold text-gray-800 truncate max-w-[220px]"
                      title={selectedPlayer.name}
                    >
                      {selectedPlayer.name}
                    </p>
                    <p className="text-sm text-gray-500">
                      {selectedPlayer?.category || "N/A"}
                    </p>
                  </div>
                </div>

                <div className="md:w-auto w-full flex justify-end">
                  <Button
                    className="w-fit"
                    onClick={() =>
                      navigate(`/player-details/${selectedPlayer?.userId}`)
                    }
                  >
                    View Profile
                  </Button>

                </div>
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm">
                {/* Player ID */}
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Player ID</span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer?.id}
                  </span>
                </div>

                {/* Game / Sport */}
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Game / Sport</span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer?.category || "N/A"}
                  </span>
                </div>

                {/* Skill Level */}
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Skill Level</span>
                  <span className="text-gray-800 text-right">
                    {selectedPlayer?.mySkillLevel || "N/A"}
                  </span>
                </div>

                {/* Achievements */}
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Achievements</span>
                  <span
                    className="text-gray-800 text-right max-w-[250px] whitespace-pre-line"
                    title={selectedPlayer?.achievements}
                  >
                    {selectedPlayer?.achievements || "N/A"}
                  </span>
                </div>

                {/* Location */}
                <div className="flex justify-between gap-3 pb-2 border-b">
                  <span className="font-medium text-gray-500">Location</span>
                  <span className="text-highlight text-right max-w-[250px]">
                    {selectedPlayer?.location?.address || "N/A"}
                  </span>
                </div>

                {/* Description */}
                <div className="flex justify-between gap-3">
                  <span className="font-medium text-gray-500">Description</span>
                  <span
                    className="text-gray-800 text-right max-w-[250px]"
                    title={selectedPlayer?.description}
                  >
                    {selectedPlayer?.description || "N/A"}
                  </span>
                </div>
              </div>

              <div className="flex justify-center">
                <Button onClick={() => setIsOpen(true)}>Send request</Button>
              </div>

              {isOpen && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
                  <div className="bg-white p-3 rounded-xl shadow-2xl max-w-xs w-full text-center">
                    <div className="flex justify-end mb-2">
                      <X className="w-auto text-white bg-brand-gradient rounded-lg" onClick={() => setIsOpen(false)} />
                    </div>

                    <h3 className="text-xl font-bold mb-2">Send Request</h3>

                    <p className="mb-4 text-gray-600">
                      Do you want to send a request?
                    </p>

                    {/* Buttons */}
                    <div className="flex justify-end gap-3">
                      <Button
                        fullWidth
                        variant="secondary"
                        onClick={() => setIsOpen(false)}
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => {
                          dispatch(
                            sendJoinAllCardRequest(
                              {
                                language: "en",
                                cardId: selectedPlayer?.id,
                                cardType: "join",
                              },
                              null,
                              () => setIsOpen(false)
                            )
                          );
                        }}
                      >
                        Yes
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SportCard;
